import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss'],
})
export class ReportDetailsComponent implements OnInit {
  public paramId: number;
  public report: any;
  public showHelp = false;
  public lockHelp = false;

  constructor(private activatedRoute: ActivatedRoute, private genericService: GenericService, private endpoints: Endpoints) {}

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.paramId = +params['params'].id;
    });
    this.getReportTypes();
    console.log(this.paramId);
  }

  getReportTypes() {
    this.genericService.GET(this.endpoints.GET_REPORT_TYPES, true).subscribe((resp: Object) => {
      const reports: any[] = resp['body'];
      this.report = reports.find((elem) => elem.ID == this.paramId);
      console.log(this.report);
    });
  }
}
